import type { FaireProductEntity } from "../../entity_types/product";

export const p_ajc5gtfpan: FaireProductEntity = {
  token: "p_ajc5gtfpan",
  type: "product",
  name: "Soft Knit Triangle Scarf – Cozy Chic Korean Style",
  brandToken: "b_3mpqvcxzwd",
  brandName: "LadyJuneAccessories",
  imageUrl:
    "https://cdn.faire.com/fastly/31f6f09b2831432c36564643c14c3c4f5a89bdbad0a0e2fbf47d20fca6322446.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b528c93bb48d820864d0eb1f5ee028b534daf74fbd55ab2f5597868d7a480ad7.jpeg",
    "https://cdn.faire.com/fastly/26031b47946e9cc718a61b6f3618a89c5f7ebf5e77e9d0b507f984062c2f432a.png",
    "https://cdn.faire.com/fastly/42d56620f4285b5694e547ba3bba5eeb975a134d24caef71b416c4ce5d26e11a.png",
    "https://cdn.faire.com/fastly/0d285db9274f1dd48413b966250bf8ad60ae52e32c8efec57c0f754e08681e6c.png",
    "https://cdn.faire.com/fastly/13af2791db4a702d528ec3b4714f0abc5f02b26bb04e0d0edccab55462cc1c66.jpeg",
    "https://cdn.faire.com/fastly/2c69f415657fe24aee21bf153728a72277d0e45d296a5e394c9078abe287a15a.jpeg",
    "https://cdn.faire.com/fastly/5a3b53179a33cec5bf5ac7ad9c1c8b8dc54e2827542519f043cafc723f6ba6e4.jpeg",
    "https://cdn.faire.com/fastly/0b277f6f9deebfc9c9aaa73ab1efa01d3e1514bab0a22b42e0e8400bfecf59e2.jpeg",
    "https://cdn.faire.com/fastly/12ed85b580473367611f469b95fa27aa46d542be16aefbb8d5f0b823362ba4f5.jpeg",
    "https://cdn.faire.com/fastly/68b0cde50809815053a62e9d70f6cc2a32847bcf787add127ad6739785f473f7.jpeg",
    "https://cdn.faire.com/fastly/40f2e01d6045f5a21ec0331ce03de82fab27778cf3cf9065fabf5db4bb700e04.jpeg",
    "https://cdn.faire.com/fastly/c5b31a871b19feeeedbf6c80516dbc2ad8b38dcae3eda9ef230319dc0768bf92.jpeg",
  ],
  priceDollars: 10,
  description:
    "**IMPORTANT** - SIZE is different between Pure style and Stripe Style \nPure color scarf - 180cm long\nStripe scarf - 120cm long\n\nWrap yourself in warmth and effortless style with this soft knit triangle scarf — a must-have winter essential inspired by Korean minimal trends seen on Instagram and TikTok. The lightweight yet fluffy texture makes it easy to layer over coats or sweaters. Available in both stripe and solid colors, it adds a cozy, elevated touch to any outfit this season.\n\nMaterial: 5.3% Wool, 55.4% Polyester, 21.5% Acrylic, 16% Polyamide, 1.8% Spandex",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:41.390Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
